export const CREDIT_NOTE_STATUS_ENUM = {
    CREATION: { label: 'En rédaction', value: "CREATION" },
    ISSUED: { label: 'Émis', value: "ISSUED" },
    REFUNDED: { label: 'Remboursé', value: "REFUNDED" },
    ABORTED: { label: 'Annulé', value: "ABORTED" }
}

export const CREDIT_NOTE_STATUS_ENUM_ARRAY = [
    CREDIT_NOTE_STATUS_ENUM.CREATION,
    CREDIT_NOTE_STATUS_ENUM.ISSUED,
    CREDIT_NOTE_STATUS_ENUM.REFUNDED,
    CREDIT_NOTE_STATUS_ENUM.ABORTED
]

// Ordre d'affichage supposé (Rédaction → Émis → Remboursé)
export const CREDIT_NOTE_STATUS_PIPELINE = [
    CREDIT_NOTE_STATUS_ENUM.CREATION,
    CREDIT_NOTE_STATUS_ENUM.ISSUED,
    CREDIT_NOTE_STATUS_ENUM.REFUNDED,
];

export const TERMINAL_CREDIT_NOTE_STATUSES = [CREDIT_NOTE_STATUS_ENUM.ABORTED];

export function possibleCreditNoteStatusSelect(creditNote) {
    const values = [];
    const status = creditNote.status;

    // ISSUED
    if (status === CREDIT_NOTE_STATUS_ENUM.CREATION.value) {
        values.push(CREDIT_NOTE_STATUS_ENUM.ISSUED);
    }

    // REFUNDED
    if (status === CREDIT_NOTE_STATUS_ENUM.ISSUED.value) {
        values.push(CREDIT_NOTE_STATUS_ENUM.REFUNDED);
    }

    // ABORTED
    if (status !== CREDIT_NOTE_STATUS_ENUM.ABORTED.value) {
        values.push(CREDIT_NOTE_STATUS_ENUM.ABORTED);
    }

    // Current status
    values.push(CREDIT_NOTE_STATUS_ENUM[status]);

    return values;
}